if(!customElements.get('pb-newsletter'))customElements.define('pb-newsletter',class extends HTMLElement{
connectedCallback(){
this.dialog=this.querySelector('dialog');this.key='pb-newsletter-until';this.abort=new AbortController();const opts={signal:this.abort.signal};
const remember=()=>{if(!window.Shopify?.designMode)try{localStorage.setItem(this.key,String(Date.now()+Number(this.dataset.days)*86400000));}catch(e){}};
this.querySelector('.pb-newsletter-close').addEventListener('click',()=>this.dialog.close(),opts);
this.dialog.addEventListener('close',()=>{remember();if(this.previous?.isConnected)this.previous.focus();},opts);
this.dialog.addEventListener('click',e=>{if(e.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)this.dialog.close();}},opts);
document.addEventListener('shopify:section:select',e=>{if(e.detail.sectionId===this.dataset.section)this.show();},opts);
document.addEventListener('shopify:section:deselect',e=>{if(e.detail.sectionId===this.dataset.section)this.dialog.close();},opts);
this.querySelector('[data-nl-continue]')?.addEventListener('click',()=>this.dialog.close(),opts);
this.querySelector('form')?.addEventListener('submit',()=>{try{sessionStorage.setItem('pb-newsletter-position',JSON.stringify({path:location.pathname,search:location.search,y:window.scrollY}));}catch(e){}},opts);
const result=this.querySelector('[data-nl-result]');
if(result&&location.hash==='#PbNewsletterForm'){
try{
const position=JSON.parse(sessionStorage.getItem('pb-newsletter-position')||'null');
sessionStorage.removeItem('pb-newsletter-position');
history.replaceState(history.state,'',location.pathname+location.search);
if(position&&position.path===location.pathname&&position.search===location.search){
const restore=()=>window.scrollTo({top:position.y,behavior:'instant'});
requestAnimationFrame(restore);
if(document.readyState!=='complete')window.addEventListener('load',restore,{once:true,signal:this.abort.signal});
}
}catch(e){}
this.show();
if(result.dataset.nlResult==='success'){
remember();

}
return;
}
if(window.Shopify?.designMode)return;
let until=0;try{until=Number(localStorage.getItem(this.key)||0);}catch(e){}
if(until>Date.now())return;
const attempt=()=>{if(document.hidden||document.body.classList.contains('cart-drawer-open')||document.querySelector('dialog[open]')||['INPUT','TEXTAREA','SELECT'].includes(document.activeElement?.tagName)){this.timer=setTimeout(attempt,2000);return;}this.show();remember();};
this.timer=setTimeout(attempt,Number(this.dataset.delay)*1000);
}
show(){if(!this.dialog.open){this.previous=document.activeElement;this.dialog.showModal();}}
disconnectedCallback(){clearTimeout(this.timer);this.abort?.abort();if(this.dialog?.open)this.dialog.close();}
});